import React, { Component } from 'react';
import { Badge } from 'react-bootstrap';
import ComprobanteStatus from '../../support/enum/ComprobanteStatus';

class ComprobanteStatusBadge extends Component {

  get config() {
    const { status } = this.props;

    const comprobante = ComprobanteStatus.search(status) || ComprobanteStatus.undefined();

    let variant = 'success';
    let icon = 'circle';
    let text = 'Vigente';

    if (comprobante.isCancelling()) {
      variant = 'warning';
      icon = 'clock';
      text = 'Cancelando';
    } else if (comprobante.isCancelled()) {
      variant = 'danger';
      icon = 'circle';
      text = 'Cancelado';
    }

    return {
      icon,
      variant,
      text
    }
  }

  render() {
    const { variant, text } = this.config;

    return (
      <Badge pill variant={ variant }>
        { text }
      </Badge>
    )
  }
}

export default ComprobanteStatusBadge;